import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../../store';
import bemClassName from '../../utils/bem';
import Checkbox from '../../UI/Checkbox';

import './index.scss';
import Container from '../../UI/Container';
import AdvantagesSticker from '../../UI/AdvantagesSticker';
import CatalogData from '../../API/CatalodData';
import ApartamentPayment from '../../components/ApartamentPayment';
import MapComponent from '../../components/Map';
import RadioButtons from '../../UI/RadiouButtons';
import transfer from '../../assets/images/transfer.png';
import bankTransfer from '../../assets/images/bank-transfer.png';
import paymentBonus from '../../assets/images/payment-bonus.png';
import sbpTransfer from '../../assets/images/sbp-transfer.png';
import walletIcon from '../../assets/images/walletIcon.png';
import Button from '../../UI/Button';
import Modal from '../../UI/Modal';

const payment = bemClassName('payment');

const Payment = () => {
  const [data, setData] = useState<any>();
  const [accommodation, setAccommodation] = useState(false);

  const checkBoxData = [
    {
      text: 'Оплатить банковским переводом',
      img: transfer,
    },
    {
      text: 'Оплатить банковской картой',
      img: bankTransfer,
    },
    {
      text: 'Оплатить бонусами',
      img: paymentBonus,
    },
    {
      text: 'Перевести по номеру карты или СБП',
      img: sbpTransfer,
    },
    {
      text: 'Оплатить наличными при заезде*',
      img: walletIcon,
    },
  ];

  const filteredCheckBoxData = accommodation
    ? checkBoxData.filter((item) => item.text !== 'Оплатить наличными при заезде*')
    : checkBoxData;

  useEffect(() => {
    document.title = 'Оплата';
    CatalogData.getApartament({ apartamentId: '388' }).then((items) => {
      setData(items);
    });
  }, []);

  const windowWidth = useSelector((state: RootState) => state.window.windowWidth);

  const isPaswordVerified = useSelector(
    (state: RootState) => state.autorizationStatus.isPaswordVerified,
  );

  const [isOpen, setOpen] = useState(false);

  useEffect(() => {
    if (!isPaswordVerified) {
      setOpen(true);
    }
  }, [isPaswordVerified]);

  const handleCloseModal = () => {
    setOpen(false);
  };

  return (
    <Container>
      <Modal open={isOpen} handleClose={handleCloseModal}>
        <h3>Внимание!</h3>
        <p>
          Бесконтактное заселение в квартиру доступно только для верифицированных пользователей.
          Верификация доступна в{' '}
          <Link to="/" className={payment('link-modal')}>
            личном кабинете
          </Link>
          .
        </p>
        <Button text="Ок" handleExternal={handleCloseModal} />
      </Modal>

      <div className={payment('')}>
        <h2 className={payment('title')}>Внесение предоплаты за проживание</h2>
        <>
          <div className={payment('buttons-wrap')}>
            <AdvantagesSticker
              data={['Бесконтактное заселение']}
              onClick={() => setAccommodation(true)}
              crossedOut={!accommodation}
            />
            <AdvantagesSticker
              data={['Обычное заселение']}
              onClick={() => setAccommodation(false)}
              crossedOut={accommodation}
            />
          </div>
          <div className={payment('content')}>
            <div className={payment('info-box')}>
              <ApartamentPayment data={data} />
              {windowWidth >= 800 &&
                data &&
                data.address &&
                data.address.coords &&
                data.address.coords.lon &&
                data.address.coords.lat && (
                  <MapComponent
                    externalClassName={payment('room-mark')}
                    zoomMap={17}
                    dataRoom={data}
                    CenterCoordsValue={[data.address.coords.lon, data.address.coords.lat]}
                  />
                )}
            </div>
            <div className={payment('pay-way')}>
              <div className={payment('panel')}>
                <h3 className={payment('pay-header')}>Выберите способ оплаты</h3>
                <RadioButtons
                  externalClassName={payment('field')}
                  name="Peyment"
                  data={filteredCheckBoxData.map((item) => ({
                    text: item.text,
                    value: item.text,
                    img: item.img,
                  }))}
                  arrow
                  pay
                />
                <div className={payment('button-purchase')}>
                  <Button externalClassName={payment('button')} text="Оплатить" />
                  <div className={payment('purchase-info')}>
                    {accommodation ? (
                      <span className={payment('description-blue')}>
                        Будет начислено бонусных баллов +850 P
                      </span>
                    ) : (
                      <>
                        <span className={payment('description')}>Если </span>
                        <Link to="/" className={payment('link-verific')}>
                          пройти верификацию документов
                        </Link>
                        ,
                        <br />
                        <span className={payment('description')}>
                          {' '}
                          будет начислено бонусных баллов +850 P
                        </span>
                      </>
                    )}
                  </div>
                  <Checkbox
                    text="Получить скидку в виде кешбека"
                    externalClassName={payment('checkbox')}
                    // handleExternal={(value: boolean) => setCashBack(value)}
                    // checked={cashBack}
                  />
                  <p className={payment('description-special')}>
                    * - при себе необходимо иметь документы, <br />
                    удостоверяющие личность
                  </p>
                </div>
              </div>
            </div>
            {windowWidth < 800 &&
              data &&
              data.address &&
              data.address.coords &&
              data.address.coords.lon &&
              data.address.coords.lat && (
                <MapComponent
                  externalClassName={payment('full-mark')}
                  dataRoom={data}
                  mobileCatalog
                  zoomMap={12}
                  CenterCoordsValue={[data.address.coords.lon, data.address.coords.lat]}
                />
              )}
          </div>
        </>
      </div>
    </Container>
  );
};

export default Payment;
